import {
  FULL_WIDTH,
  FULL_HEIGHT,
  BLOCK_WIDTH,
  BLOCK_HEIGHT,
  TRACK_GAP
} from './env'

export function getBlockPortPosition(
  [x, y]: [number, number],
  port
): [number, number] {
  const blockPositionX = 1 + x * FULL_WIDTH
  const blockPositionY = 1 + y * FULL_HEIGHT
  switch (port) {
    case 'text-top':
      return [blockPositionX + 0.75, blockPositionY + 0.75]
    case 'text-center':
      return [blockPositionX + 0.75, blockPositionY + 1.75]
    // return [blockPositionX + Math.floor(BLOCK_WIDTH / 2), blockPositionY + 2]
    case 'top':
      return [blockPositionX + Math.floor(BLOCK_WIDTH / 2), blockPositionY]
    case 'bottom':
      return [
        blockPositionX + Math.floor(BLOCK_WIDTH / 2),
        blockPositionY + BLOCK_HEIGHT - 1
      ]
    case 'in1':
      return [blockPositionX, blockPositionY + 1]
    case 'in2':
      return [blockPositionX, blockPositionY + 3]
    case 'out1':
      return [(x + 1) * FULL_WIDTH - TRACK_GAP, blockPositionY + 1]
    case 'out2':
      return [(x + 1) * FULL_WIDTH - TRACK_GAP, blockPositionY + 3]
    default:
      throw Error(`unknown port "${port}"`)
  }
}
